"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TextAreaField", {
  enumerable: true,
  get: function get() {
    return _TextAreaField["default"];
  }
});
exports["default"] = void 0;

var _TextAreaField = _interopRequireWildcard(require("../TextAreaField"));

var _default = _TextAreaField.TextArea;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/TextArea.js
// module id = 538
// module chunks = 0